// Copyright (c) StrangeBee 2024

import React from 'react';
import { FormInstance } from 'antd/lib/form';
import SSLConfigForm from '../SSLConfigForm/SSLConfigForm';
import ProxyConfigForm from '../ProxyConfigForm/ProxyConfigForm';

interface WsConfigFormProps {
    name: string[];
    form: FormInstance;
}

const WsConfigForm = ({ name, form }: WsConfigFormProps) => {
    return (
        <>
            <ProxyConfigForm name={[...name, 'proxy']} form={form} />
            <SSLConfigForm name={[...name, 'ssl']} form={form} />
        </>
    );
};

export default WsConfigForm;
